import { I18nResolver } from "i18n-ts";

/**
 * Importing translations
 */
import * as ptBR from "locales/pt-BR";
import * as en from "locales/en-US";

// Default locale language
const i18nLang = {
  pt: ptBR,
  en: en,
  default: ptBR,
};

let i18n = new I18nResolver(i18nLang, "pt").translation["pt"];
export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.ts